import { Link } from "react-router-dom";
import logoImage from "../images/Zahira OBA Logo.png";

/** Replace with your official group URLs when ready */
const FACEBOOK_URL = "https://www.facebook.com/";
const LINKEDIN_URL = "https://www.linkedin.com/";

const linkClass =
  "block py-1.5 text-sm text-brand-blue/80 transition hover:text-brand-maroon";

const siteObaTitleClass =
  "mb-5 flex flex-wrap items-baseline gap-x-1.5 font-display text-base font-bold tracking-tight text-brand-blue";

const columnTitleClass =
  "mb-5 font-display text-base font-bold tracking-tight text-brand-blue";

const networkTitleClass =
  "mb-5 flex flex-wrap items-baseline gap-x-1.5 font-display text-base font-bold tracking-tight text-brand-blue";

export function Footer() {
  return (
    <footer className="mt-16 border-t border-brand-gray/80 bg-white text-brand-blue">
      <div className="mx-auto max-w-6xl px-4 py-12 md:py-14">
        <div className="flex flex-col gap-6 border-b border-brand-gray/50 pb-10 md:flex-row md:items-center md:justify-between md:gap-10">
          <div className="flex items-start gap-4">
            <img
              src={logoImage}
              alt=""
              className="h-11 w-auto shrink-0 object-contain md:h-12"
            />
            <div>
              <p className="font-display text-lg font-bold leading-tight text-brand-blue">
                Old Boys&apos; Association
              </p>
              <p className="mt-0.5 text-xs font-semibold uppercase tracking-[0.2em] text-brand-maroon">
                Zahira College Mawanella
              </p>
            </div>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-brand-blue/70 md:text-right">
            Serving our alma mater and fellow old boys across branches, batches,
            and associations.
          </p>
        </div>

        <nav
          className="grid gap-10 pt-10 sm:grid-cols-2 lg:grid-cols-3 lg:gap-12"
          aria-label="Footer"
        >
          <div>
            <h2 className={siteObaTitleClass}>
              <span>OBA</span>
            </h2>
            <ul className="space-y-0.5">
              <li>
                <Link to="/" className={linkClass}>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className={linkClass}>
                  About
                </Link>
              </li>
              <li>
                <Link to="/pillars" className={linkClass}>
                  Pillars
                </Link>
              </li>
              <li>
                <Link to="/news" className={linkClass}>
                  OBA News
                </Link>
              </li>
              <li>
                <Link to="/projects" className={linkClass}>
                  OBA Projects
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h2 className={columnTitleClass}>Alumni</h2>
            <ul className="space-y-0.5">
              <li>
                <Link to="/alumni/branches" className={linkClass}>
                  Branches
                </Link>
              </li>
              <li>
                <Link to="/alumni/batches" className={linkClass}>
                  Batches
                </Link>
              </li>
              <li>
                <Link to="/alumni/associations" className={linkClass}>
                  Associations
                </Link>
              </li>
              <li>
                <Link to="/news/other" className={linkClass}>
                  Affiliated news
                </Link>
              </li>
              <li>
                <Link to="/projects/other" className={linkClass}>
                  Affiliated projects
                </Link>
              </li>
            </ul>
          </div>

          <div className="sm:col-span-2 lg:col-span-1">
            <h2 className={networkTitleClass}>
              <span>Network</span>
            </h2>
            <ul className="space-y-0.5">
              <li>
                <Link to="/alumni/membership" className={linkClass}>
                  Membership
                </Link>
              </li>
              <li>
                <a
                  href={FACEBOOK_URL}
                  className={linkClass}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook
                </a>
              </li>
              <li>
                <a
                  href={LINKEDIN_URL}
                  className={linkClass}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </nav>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-brand-gray/40 pt-8 text-xs text-brand-blue/55 sm:flex-row sm:text-left">
          <p>
            © {new Date().getFullYear()} Old Boys&apos; Association, Zahira College
            Mawanella. All rights reserved.
          </p>
          <Link
            to="/admin"
            className="text-brand-blue/35 transition hover:text-brand-maroon"
          >
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
